import React, { useState } from 'react'

interface DebugPanelProps {
  rawSessionsCount: number
  groupedSessionsCount: number
  duplicatesInfo: Array<{
    guestName: string
    sessionKey: string
    duplicateCount: number
    totalUnread: number
  }>
}

export const DebugPanel: React.FC<DebugPanelProps> = ({
  rawSessionsCount,
  groupedSessionsCount,
  duplicatesInfo
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  
  // Só mostrar se houver duplicatas ou diferença entre raw e grouped
  const shouldShow = duplicatesInfo.length > 0 || rawSessionsCount !== groupedSessionsCount
  
  if (!shouldShow) return null

  return (
    <div className="mb-4">
      <div className="card bg-light-warning">
        <div className="card-body p-3">
          <div 
            className="d-flex align-items-center justify-content-between cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className="d-flex align-items-center">
              <i className="fas fa-bug text-warning me-2"></i>
              <strong className="text-warning">
                Debug: {duplicatesInfo.length} sessão(ões) com duplicatas encontradas
              </strong>
            </div>
            <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} text-warning`}></i>
          </div>

          {isExpanded && (
            <div className="mt-3">
              <div className="row mb-3">
                <div className="col-6">
                  <div className="text-center">
                    <div className="fw-bold text-dark">{rawSessionsCount}</div>
                    <div className="fs-7 text-muted">Sessões Brutas</div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="text-center">
                    <div className="fw-bold text-success">{groupedSessionsCount}</div>
                    <div className="fs-7 text-muted">Após Agrupamento</div>
                  </div>
                </div>
              </div>

              {duplicatesInfo.length > 0 && (
                <div>
                  <h6 className="text-dark mb-2">Sessões Consolidadas:</h6>
                  <div className="overflow-auto" style={{ maxHeight: '200px' }}>
                    {duplicatesInfo.map((info, index) => (
                      <div key={index} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <div>
                          <span className="fw-bold">{info.guestName}</span>
                          <span className="text-muted ms-2 fs-7">{info.sessionKey}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="badge badge-warning">
                            {info.duplicateCount} duplicatas
                          </span>
                          {info.totalUnread > 0 && (
                            <span className="badge badge-danger">
                              {info.totalUnread} não lidas
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="mt-3 p-2 bg-light rounded">
                <small className="text-muted">
                  <i className="fas fa-info-circle me-1"></i>
                  As sessões duplicadas foram automaticamente consolidadas. 
                  Este painel só aparece quando há duplicatas detectadas.
                </small>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>
        {`
          .cursor-pointer {
            cursor: pointer;
          }
          .cursor-pointer:hover {
            opacity: 0.8;
          }
        `}
      </style>
    </div>
  )
}